export default "__VITE_ASSET__TAuuM2UT__"